import { useContext } from "react";

// context
import { DevicesContext } from "./index";

export const useDevices = () => {
    return useContext(DevicesContext);
};
